import services from '@/services/ascentiaServiceIndex'
import { ACMF_REPORT_DETAILS_CONSTS as ARVC } from '../consts'
import stores from '..'
import { generateGUID } from '@/utilities/guid'

const state = {
  isApuReport: true,
  reportData: [],
  reportAlerts: [],
  faultMonitors: [],
  isReportDataLoading: false,
  isAircraftDetailsLoading: false,
  isParameterAlertLoading: false,
  isParameterDefinitionLoading: false,
  isParameterGraphLoading: false,
  isFleetGraphLoading: false,
  isRawReportTextLoading: false,
  aircraftDetails: [],
  parameterAlert: {},
  parameterDefinition: {},
  parameterGraph: {},
  fleetGraphData: {},
  rawReportText: '',
  nextReportId: null,
  previousReportId: null,
  isReportExportLoading: false,
  reportTimeLinesData: [],
  isReportTimeLinesDataLoading: false,
  graphGroupsPerReportType: [],
  reportType: {},
  reportPlotGraphGroups: {},
  reportPlotGraph: {},
}

const getters = {
  isApuReport: state => {
    return state.isApuReport
  },
  reportDataWithUniqueIds: state => {
    const arrayData = state.reportData
    if (arrayData && arrayData.length > 0) {
      const items = arrayData.map(item => {
        const itemGuid = generateGUID()
        if (item.values) {
          const updatedValues = []
          let rowIndex = 0
          item.values.forEach(valueItem => {
            const cells = valueItem.map((cell, index) => {
              return {
                uniqueId:
                  itemGuid + '__' + index.toString() + '__' + generateGUID(),
                rowIndex,
                ...cell,
              }
            })
            rowIndex++
            updatedValues.push(cells)
          })
          return {
            uniqueId: itemGuid,
            ...item,
            values: updatedValues,
          }
        }
        return {
          uniqueId: itemGuid,
          ...item,
        }
      })
      return items
    }
    return []
  },
}

const mutations = {
  [ARVC.UPDATE_IS_APU_REPORT]: (state, data) => (state.isApuReport = data),
  [ARVC.UPDATE_REPORT_DATA]: (state, data) => (state.reportData = data),
  [ARVC.UPDATE_REPORT_TIMELINES_DATA]: (state, data) =>
    (state.reportTimeLinesData = data),
  [ARVC.UPDATE_REPORT_TIMELINES_DATA_LOADING]: (state, data) =>
    (state.isReportTimeLinesDataLoading = data),
  [ARVC.UPDATE_REPORT_ALERTS]: (state, data) => (state.reportAlerts = data),
  [ARVC.UPDATE_FAULT_MONITORS]: (state, data) => (state.faultMonitors = data),
  [ARVC.UPDATE_REPORT_DATA_LOADING]: (state, data) =>
    (state.isReportDataLoading = data),
  [ARVC.UPDATE_PARAMETER_ALERT]: (state, data) => (state.parameterAlert = data),
  [ARVC.UPDATE_PARAMETER_DEFINITION]: (state, data) =>
    (state.parameterDefinition = data),
  [ARVC.UPDATE_PARAMETER_ALERT_LOADING]: (state, data) =>
    (state.isParameterAlertLoading = data),
  [ARVC.UPDATE_PARAMETER_DEFINITION_LOADING]: (state, data) =>
    (state.isParameterDefinitionLoading = data),
  [ARVC.UPDATE_FLEET_GRAPH_LOADING]: (state, data) =>
    (state.isFleetGraphLoading = data),
  [ARVC.UPDATE_PARAMETER_GRAPH]: (state, data) => (state.parameterGraph = data),
  [ARVC.UPDATE_FLEET_COMPARISON_DATA]: (state, data) =>
    (state.fleetGraphData = data),
  [ARVC.UPDATE_PARAMETER_GRAPH_LOADING]: (state, data) =>
    (state.isParameterGraphLoading = data),
  [ARVC.UPDATE_AIRCRAFT_DETAILS]: (state, data) =>
    (state.aircraftDetails = data),
  [ARVC.UPDATE_AIRCRAFT_DETAILS_LOADING]: (state, data) =>
    (state.isAircraftDetailsLoading = data),
  [ARVC.UPDATE_NEXT_REPORT_ID]: (state, data) => (state.nextReportId = data),
  [ARVC.UPDATE_PREVIOUS_REPORT_ID]: (state, data) =>
    (state.previousReportId = data),
  [ARVC.UPDATE_RAW_REPORT_TEXT]: (state, data) => (state.rawReportText = data),
  [ARVC.UPDATE_RAW_REPORT_TEXT_LOADING]: (state, data) =>
    (state.isRawReportTextLoading = data),
  [ARVC.UPDATE_REPORT_EXPORT_LOADING]: (state, data) =>
    (state.isReportExportLoading = data),
  [ARVC.UPDATE_GRAPH_GROUPS]: (state, data) =>
    (state.graphGroupsPerReportType = data),
  [ARVC.UPDATE_REPORT_TYPE]: (state, data) => (state.reportType = data),
  [ARVC.UPDATE_REPORT_PLOT_GROUPS]: (state, data) => {
    if (!data || data.graphs) {
      state.reportPlotGraphGroups = data
    } else {
      // checking if only one graph was updated and adding it to the groups state
      const newGraph = state.reportPlotGraphGroups.graphs.map(item => {
        if (item.graphId === data.graphId) {
          return {
            ...data,
          }
        } else {
          return {
            ...item,
          }
        }
      })
      state.reportPlotGraphGroups = {
        ...state.reportPlotGraphGroups,
        graphs: newGraph,
      }
    }
  },
  [ARVC.UPDATE_REPORT_PLOT]: (state, data) => (state.reportPlotGraph = data),
}

const actions = {
  async [ARVC.GET_REPORT_DATA]({ commit }, params) {
    commit(ARVC.UPDATE_REPORT_DATA_LOADING, true)
    try {
      const response = await services.acmf.getData('reportData', params, true)
      commit(ARVC.UPDATE_IS_APU_REPORT, response.data.isApuReport || false)
      commit(ARVC.UPDATE_REPORT_DATA, response.data.reportData)
      commit(ARVC.UPDATE_REPORT_ALERTS, response.data.reportAlerts)
      commit(ARVC.UPDATE_FAULT_MONITORS, response.data.faultMonitors)
      const reportType = {
        acmfReportTypeId: response.data.acmfReportTypeId,
        acmfReportNumber: response.data.acmfReportNumber,
      }
      commit(ARVC.UPDATE_REPORT_TYPE, reportType)
      stores.commit('updateCurrentEccn', response.data.eccnNumber)
    } catch (error) {
      console.log(ARVC.GET_REPORT_DATA + ': error ' + error)
      stores.commit('updateApiDown', true) // Thoughts on forcing 500 page if this fails?
      commit(ARVC.UPDATE_IS_APU_REPORT, false)
      commit(ARVC.UPDATE_REPORT_DATA, [])
      commit(ARVC.UPDATE_REPORT_ALERTS, [])
      commit(ARVC.UPDATE_FAULT_MONITORS, [])
    } finally {
      commit(ARVC.UPDATE_REPORT_DATA_LOADING, false)
    }
  },

  async [ARVC.GET_REPORT_TIMELINES_DATA]({ commit }, params) {
    commit(ARVC.UPDATE_REPORT_TIMELINES_DATA_LOADING, true)
    try {
      const response = await services.acmf.getData(
        'reportTimeLinesData',
        params,
        true,
      )
      const data = response.data
      commit(ARVC.UPDATE_REPORT_TIMELINES_DATA, data)
    } catch (error) {
      console.log(ARVC.GET_REPORT_TIMELINES_DATA + ': error ' + error)
      commit(ARVC.UPDATE_REPORT_TIMELINES_DATA, [])
    } finally {
      commit(ARVC.UPDATE_REPORT_TIMELINES_DATA_LOADING, false)
    }
  },
  async [ARVC.GET_AIRCRAFT_DETAILS]({ commit }, tailNumber) {
    commit(ARVC.UPDATE_AIRCRAFT_DETAILS_LOADING, true)
    try {
      const response = await services.acmf.getData(
        'aircraftDetails',
        tailNumber,
        true,
      )
      const data = response.data.map(item => {
        return {
          id: item.id,
          title: item.title,
          value: item.value === null ? 'N/A' : item.value,
        }
      })
      commit(ARVC.UPDATE_AIRCRAFT_DETAILS, data)
    } catch (error) {
      console.log(ARVC.GET_AIRCRAFT_DETAILS + ': error ' + error)
      commit(ARVC.UPDATE_AIRCRAFT_DETAILS, [])
    } finally {
      commit(ARVC.UPDATE_AIRCRAFT_DETAILS_LOADING, false)
    }
  },
  async [ARVC.GET_PARAMETER_ALERT]({ commit }, params) {
    commit(ARVC.UPDATE_PARAMETER_ALERT_LOADING, true)
    try {
      const parameterDefinitionFilters = {
        id: params.parameterId,
        tailNumber: params.tailNumber,
      }
      const response = await services.acmf.getData(
        'parameterDefinition',
        parameterDefinitionFilters,
      )
      const paramDetails = {
        status: params.parameterDetails.status,
        value: params.parameterDetails.value
          ? params.parameterDetails.value
          : params.parameterDetails.text,
      }
      const paramAlert = {
        ...response.data,
        parameterDetails: paramDetails,
      }
      commit(ARVC.UPDATE_PARAMETER_ALERT, paramAlert)
    } catch (error) {
      console.log(ARVC.GET_PARAMETER_ALERT + ': error ' + error)
      commit(ARVC.UPDATE_PARAMETER_ALERT, {})
    } finally {
      commit(ARVC.UPDATE_PARAMETER_ALERT_LOADING, false)
    }
  },
  async [ARVC.GET_PARAMETER_DEFINITION]({ commit }, params) {
    commit(ARVC.UPDATE_PARAMETER_DEFINITION_LOADING, true)
    try {
      const parameterDefinitionFilters = {
        id: params.parameterId,
        tailNumber: params.tailNumber,
      }
      const response = await services.acmf.getData(
        'parameterDefinition',
        parameterDefinitionFilters,
      )
      commit(ARVC.UPDATE_PARAMETER_DEFINITION, response.data)
    } catch (error) {
      console.log(ARVC.GET_PARAMETER_DEFINITION + ': error ' + error)
      commit(ARVC.UPDATE_PARAMETER_DEFINITION, {})
    } finally {
      commit(ARVC.UPDATE_PARAMETER_DEFINITION_LOADING, false)
    }
  },
  async [ARVC.GET_PARAMETER_GRAPH]({ commit }, params) {
    commit(ARVC.UPDATE_PARAMETER_GRAPH_LOADING, true)
    try {
      const parameterDefinitionFilters = {
        id: params.parameterId,
        tailNumber: params.tailNumber,
        isDataElementId: params.isDataElementId || false,
        reportNumber: params.reportNumber || null,
      }
      const parameterDefinition = await services.acmf.getData(
        'parameterDefinition',
        parameterDefinitionFilters,
        true,
      )
      const graphFilters = {
        parameterId: params.parameterId,
        tailNumber: params.tailNumber,
        startDate: params.startDate || null,
        endDate: params.endDate || null,
        isDataElementId: params.isDataElementId || false,
        reportNumber: params.reportNumber || null,
      }
      const response = await services.acmf.getData(
        'parameterGraph',
        graphFilters,
        true,
      )
      const paramGraph = {
        ...parameterDefinition.data,
        values: response.data,
        tail: params.tailNumber,
      }
      commit(ARVC.UPDATE_PARAMETER_GRAPH, paramGraph)
    } catch (error) {
      console.log(ARVC.GET_PARAMETER_GRAPH + ': error ' + error)
      commit(ARVC.UPDATE_PARAMETER_GRAPH, {})
    } finally {
      commit(ARVC.UPDATE_PARAMETER_GRAPH_LOADING, false)
    }
  },
  async [ARVC.GET_SERIES_DATA_GRAPH]({ commit }, params) {
    commit(ARVC.UPDATE_PARAMETER_GRAPH_LOADING, true)
    try {
      const parameterDefinitionFilters = {
        id: params.parameterId,
        tailNumber: params.tailNumber,
      }
      const parameterDefinition = await services.acmf.getData(
        'parameterDefinition',
        parameterDefinitionFilters,
        true,
      )
      const paramGraph = {
        ...parameterDefinition.data,
        isSeriesData: params.isSeriesData,
        values: params.values,
        tail: params.tailNumber,
      }
      commit(ARVC.UPDATE_PARAMETER_GRAPH, paramGraph)
    } catch (error) {
      console.log(ARVC.GET_SERIES_DATA_GRAPH + ': error ' + error)
      commit(ARVC.UPDATE_PARAMETER_GRAPH, {})
    } finally {
      commit(ARVC.UPDATE_PARAMETER_GRAPH_LOADING, false)
    }
  },
  async [ARVC.GET_FLEET_COMPARISON_DATA]({ commit }, params) {
    try {
      commit(ARVC.UPDATE_FLEET_GRAPH_LOADING, true)
      const parameterDefinitionFilters = {
        id: params.parameterId,
        tailNumber: params.tailNumber,
      }
      const response = await services.acmf.getData(
        'parameterDefinition',
        parameterDefinitionFilters,
        true,
      )
      const fleetComparisonDataResponse = await services.acmf.getData(
        'fleetGraph',
        params,
        true,
      )
      const fleetComparisonData = fleetComparisonDataResponse.data
        ? fleetComparisonDataResponse.data
        : {
            primaryPlots: [],
            secondaryPlots: [],
          }
      const fleetGraph = {
        parameterDefinition: { ...response.data },
        fleetValues: { ...fleetComparisonData },
      }
      commit(ARVC.UPDATE_FLEET_COMPARISON_DATA, fleetGraph)
    } catch (error) {
      commit(ARVC.UPDATE_FLEET_COMPARISON_DATA, {})
      console.log(ARVC.GET_FLEET_COMPARISON_DATA + ': error ' + error)
    } finally {
      commit(ARVC.UPDATE_FLEET_GRAPH_LOADING, false)
    }
  },
  async [ARVC.GET_RAW_REPORT_TEXT]({ commit }, reportId) {
    commit(ARVC.UPDATE_RAW_REPORT_TEXT_LOADING, true)
    try {
      const response = await services.acmf.getData('rawReport', reportId, true)
      const rawText = response.data.rawReport
      const formattedText = `<pre>${rawText}</pre>`
      commit(ARVC.UPDATE_RAW_REPORT_TEXT, formattedText)
    } catch (error) {
      console.log(ARVC.GET_RAW_REPORT_TEXT + ': error ')
      commit(ARVC.UPDATE_RAW_REPORT_TEXT, '')
    } finally {
      commit(ARVC.UPDATE_RAW_REPORT_TEXT_LOADING, false)
    }
  },
  async [ARVC.GET_NEXT_REPORT_ID]({ commit }, params) {
    try {
      commit(ARVC.UPDATE_PREVIOUS_REPORT_ID, null)
      commit(ARVC.UPDATE_NEXT_REPORT_ID, null)

      const response = await services.acmf.getData('nextReportId', params, true)
      let newId

      if (
        response &&
        response.data &&
        response.data.length &&
        response.data.length > 0
      ) {
        newId = response.data[0]
      } else {
        newId = null
      }

      if (params.ascending === true) {
        commit(ARVC.UPDATE_NEXT_REPORT_ID, newId)
      } else {
        commit(ARVC.UPDATE_PREVIOUS_REPORT_ID, newId)
      }
    } catch (error) {
      console.log(ARVC.GET_NEXT_REPORT_ID + ': error ' + error)
    }
  },
  async [ARVC.GET_EXPORTED_REPORTS_GIVEN_REPORT_ID]({ commit }, reportId) {
    try {
      commit(ARVC.UPDATE_REPORT_EXPORT_LOADING, true)
      await services.acmf.getData('exportedReportsGivenId', reportId, true)
    } catch (error) {
      console.log(ARVC.GET_EXPORTED_REPORTS_GIVEN_REPORT_ID + ': error ')
    } finally {
      commit(ARVC.UPDATE_REPORT_EXPORT_LOADING, false)
    }
  },
  async [ARVC.GET_GRAPH_GROUPS_PER_REPORT_TYPE]({ commit }) {
    try {
      const response = await services.acmf.getData(
        'graphGroupsPerReportType',
        null,
        true,
      )
      if (response.data) {
        commit(ARVC.UPDATE_GRAPH_GROUPS, response.data)
      }
    } catch (error) {
      console.log(ARVC.GET_GRAPH_GROUPS_PER_REPORT_TYPE + ': error ' + error)
    }
  },
  async [ARVC.GET_REPORT_PLOT_GROUPS]({ commit }, params) {
    try {
      const response = await services.acmf.getData(
        'reportPlotGraphGroups',
        params,
        true,
      )
      if (response.data) {
        commit(ARVC.UPDATE_REPORT_PLOT_GROUPS, response.data)
      }
    } catch (error) {
      commit(ARVC.UPDATE_REPORT_PLOT_GROUPS, null)
      console.log(ARVC.GET_REPORT_PLOT_GROUPS + ': error ' + error)
    }
  },
  async [ARVC.GET_REPORT_PLOT]({ commit }, params) {
    try {
      const response = await services.acmf.getData(
        'reportPlotGraph',
        params,
        true,
      )
      if (response.data) {
        commit(ARVC.UPDATE_REPORT_PLOT, response.data)
        commit(ARVC.UPDATE_REPORT_PLOT_GROUPS, response.data)
      }
    } catch (error) {
      console.log(ARVC.GET_REPORT_PLOT + ': error ' + error)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
